import { render, staticRenderFns } from "./Pxbm.vue?vue&type=template&id=3d11fba2"
import script from "./Pxbm.vue?vue&type=script&lang=js"
export * from "./Pxbm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports